import React from 'react';
import { TextMessage } from 'components/tt-forms/common';
import { ShowIf } from 'components/utils';
import { ContainerFileDinhKem } from 'components/upload';

class CanBoKiemTraDeXuatView extends React.Component {

  render() {
    return (
      <div>
        <div className="items-form">
          <div className="row pl10 pr10">
            <TextMessage
              className="col-12"
              value={this.props.thongTinXuLyGiaiQuyet.thongTinYeuCauKiemTraDeXuatInfo.yKienXuLy ? this.props.thongTinXuLyGiaiQuyet.thongTinYeuCauKiemTraDeXuatInfo.yKienXuLy : ''}
              label='Ý kiến xử lý:' />
          </div>
          <div className="container-filedinhkem">
            <ContainerFileDinhKem label="Danh sách văn bản xử lý" disableAttachFile={true} bindValidator={this} dataShow={this.props.listTaiLieuVanThuKiemTraDeXuat} />
          </div>
          <ShowIf condition={!this.props.boSungThongTin && (this.props.noiDungBoSungHoSo != '' && this.props.noiDungBoSungHoSo != null)}>
            <div className='row pl15 pr15'>
              <div className="col-100 no-gutter">
                <div className="wrap-big-line pt5 pb15">
                  <span className="big-border"></span>
                </div>
                <div className="col-100 no-gutter mt5">
                  <h2 className="title-14 mb15">BỔ SUNG THÔNG TIN</h2>
                  <div className="row pl10 pr10">
                    <div className="col-50 no-gutter">
                      <TextMessage className="col-50 mb0-18" label="Lý do bổ sung:" value={String(this.props.noiDungBoSungHoSo)}/>
                    </div>
                  </div>
                </div>
                <div className="col-100 pb5 no-gutter container-filedinhkem">
                  <ContainerFileDinhKem name="BoSungTT" label="Danh sách văn bản bổ sung" hideDescription={true} bindValidator={this} dataShow={this.props.listTaiLieuVanThuBoSungHoSo} disableAttachFile={true}/>
                </div>
              </div>
            </div>
          </ShowIf>
        </div>
      </div>
    );
  }
}

CanBoKiemTraDeXuatView.defaultProps = {
  validators: {}
}

export default CanBoKiemTraDeXuatView;


// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/xu-ly-don/form-kiem-tra-de-xuat/chuyen-vien/CanBoKiemTraDeXuatView.jsx